// extracted by mini-css-extract-plugin
export var statItem = "_fw-1";
export var statsRow = "_fw-0";